import { ContainerTypeEnum, Currency, Incoterms } from 'api';
import { yup } from 'form';

const AddressDetailsSchema = yup
  .object({
    country_code: yup.string().required(),
    full_address: yup.string().required(),
    latitude: yup.number().required(),
    longitude: yup.number().required(),
  })
  .nullable();

export const createTransportCostsEstimateSchema = yup
  .object({
    container_type: yup.string().oneOf(Object.values(ContainerTypeEnum)).required(),
    currency: yup.string().oneOf(Object.values(Currency)).required(),
    demand_incoterm: yup.string().oneOf(Object.values(Incoterms)).required(),
    destination: AddressDetailsSchema.optional(),
    nearest_city_max_radius: yup.number().required(),
    origin: AddressDetailsSchema.optional(),
    port_of_discharge: yup.number().nullable().optional(),
    port_of_loading: yup.number().nullable().optional(),
    supply_incoterm: yup.string().oneOf(Object.values(Incoterms)).required(),
  })
  .transform((value) => {
    return {
      ...value,
      destination: value.destination || null,
      origin: value.origin || null,
    };
  })
  .test('origin-or-port_of_loading', 'Either origin or port_of_loading is required', function (value) {
    if (!value.origin && !value.port_of_loading) {
      return this.createError({ message: 'Either origin or port_of_loading is required', path: 'origin' });
    }
    return true;
  })
  .test('destination-or-port_of_discharge', function (value) {
    if (!value.destination && !value.port_of_discharge) {
      return this.createError({ message: 'Either destination or port_of_discharge is required', path: 'destination' });
    }
    return true;
  })
  .required();
